import React from 'react';
import { BsPlayCircleFill } from 'react-icons/bs';
import { BiSolidFilePdf } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { IMAGE_BASE_URL } from '../../config';

const TaskCard = ({ task, courseId }) => {

  const isProgressLoaded = task.progress_user_task !== null && task.progress_user_task !== undefined;
  const isInProgress = isProgressLoaded && task.progress_user_task > 0 && task.progress_user_task < 100;
  const isFinalizado = task.progress_user_task === 100;
  const isSinIniciar = task.progress_user_task === 0;

  const navigate = useNavigate();

  const getProgressText = () => {
    if (!isProgressLoaded) return "Error al cargar el progreso";
    if (isFinalizado) return "Finalizado";
    if (isSinIniciar) return "Sin iniciar";
    return `En curso ${task.progress_user_task}%`;
  };

  const getProgressColor = () => {
    if (!isProgressLoaded) return "bg-red-400";
    if (isFinalizado || isInProgress) return "bg-green-400";
    return "bg-gray-400";
  };

  const getCardClass = () => {
    if (!task.is_active) return;
    if (!task.is_available) return "cursor-not-allowed not-allowed-gradient-internal-card";
    if (isProgressLoaded && task.progress_user_task > 0) return "cursor-pointer gradient-internal-card";
    return "cursor-pointer not-allowed-gradient-internal-card";
  };

  const goToDetailCourse = () => {
    localStorage.setItem('courseId', courseId);
    navigate(`/cursos${task.url_front}${task.id}`);
  };


  return (
    <div
      className={`${getCardClass()} pt-4 relative rounded-t-2xl shadow-lg flex flex-col items-center justify-end`}
      style={{
        backgroundImage: `url(${IMAGE_BASE_URL}${task.image_card})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
      onClick={() => {
        if (!task.is_available) return;
        goToDetailCourse();
      }}

    >
      <div className="absolute top-[-20px] z-10">
        {task.type === 'video' ? (
          <BsPlayCircleFill
            className="rounded-full"
            style={{
              fontSize: '50px',
              fill: 'white',
              background: task.is_active ? '#4D2484' : '#9ca3af',
              boxShadow: 'rgba(0, 0, 0, 1) 0px 0px 8px'
            }}
          />
        ) : (
          <BiSolidFilePdf
            style={{ fontSize: '50px', fill: '#FFFFFF' }}
          />
        )}
      </div>
      <div className="flex flex-col items-center text-center justify-start w-full relative z-10">
        <div className="mt-4 mb-0 h-20 mx-2">
          <h5 className="text-white text-center text-xs ApisBold">
            {task.title}
          </h5>
        </div>
        <div className={`${getProgressColor()} w-full py-2`}>
          <p className="text-white text-center text-[10px] ApisBold m-0 p-0">
            {getProgressText()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TaskCard;